import React, { useState, useRef, useEffect } from "react";
import SimpleReactValidator from 'simple-react-validator';
import {
  Card,
  Typography,
  Input,
  Button,
  message,
  Divider,
} from "antd";
import {
  QrcodeOutlined,
  CopyOutlined,
  MailOutlined,
} from "@ant-design/icons";
import {
  SpError,
} from '../../widgetDesign';

const { Title, Text } = Typography;

type Props = {
  createZellPayment: Function,
}

const ZelleCheckout = (props: Props) => {
  const { createZellPayment } = props;
  const [, forceUpdate] = useState();
  const [copied, setCopied] = useState(false);
  const [zelleCode, setZelleCode] = useState("");

  const simpleValidator = useRef(new SimpleReactValidator({}));

  const zelleId = "payment@zelle.com";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(zelleId);
      setCopied(true);
      message.success("Copied!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      message.error("Copy failed");
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    createZellPayment(zelleCode);

  };

  return (
    <div style={styles.container}>
      <Card style={styles.qrCard} bordered={false}>
        <div style={styles.qrHeader}>
          <QrcodeOutlined />
          <Text strong style={{ color: "#1677ff" }}>
            SCAN TO PAY
          </Text>
        </div>

        <div style={styles.qrBox}>
          <img
            src="https://swirepay-icon-prod.s3.ap-south-1.amazonaws.com/icon_url/zellQR.png"
            alt="QR"
            width='200'
          />
        </div>

        <div style={styles.status}>
          <span style={styles.greenDot}></span>
          <Text type="secondary">Ready to scan</Text>
        </div>
      </Card>
      {/* <div style={styles.copySection}>
        <Title level={4} style={{ letterSpacing: 2 }}>
          COPY ZELLE ID
        </Title>

        <div style={styles.copyRow}>
          <div style={styles.inputWrapper}>
            <Input value={zelleId} readOnly bordered={false} />
            <Button icon={<CopyOutlined />} onClick={handleCopy} />
          </div>

          {copied && <div style={styles.copiedBadge}>Copied!</div>}
        </div>
      </div> */}

      <Divider style={{ width: "60%" }} />
      <Title level={5} style={{ textAlign: "center" }}>
        Once you complete the Zelle payment, enter your Zelle ID and click submit
      </Title>
      <Card style={styles.formCard}>
        <Text strong>
          <MailOutlined /> Enter Your Zelle ID{" "}
          <span style={{ color: "red" }}>*</span>
        </Text>

        <Input
          placeholder="Enter email or phone"
          value={zelleCode}
          onChange={(e) => setZelleCode(e.currentTarget.value)}
          style={{ marginTop: 10, height: 45 }}
        />
        <SpError>
          {simpleValidator.current.message('Zelle ID', zelleCode, 'required')}
        </SpError>

        <Text type="secondary" style={{ fontSize: 12 }}>
          Enter the email or phone number used for payment
        </Text>
      </Card>
      <Button type="primary" size="large" style={styles.button} onClick={handleSubmit}>
        SUBMIT PAYMENT
      </Button>
    </div>
  );
};

export default ZelleCheckout;

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: 40,
    background: "#f5f7fa",
    minHeight: "auto",
  },

  qrCard: {
    width: 280,
    textAlign: "center",
    borderRadius: 16,
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
  },

  qrHeader: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
    marginBottom: 12,
  },

  qrBox: {
    padding: 15,
    background: "#fafafa",
    borderRadius: 12,
  },

  status: {
    marginTop: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 6,
  },

  greenDot: {
    width: 8,
    height: 8,
    background: "green",
    borderRadius: "50%",
  },

  copySection: {
    marginTop: 30,
    textAlign: "center",
  },

  copyRow: {
    display: "flex",
    alignItems: "center",
    gap: 15,
    marginTop: 15,
  },

  inputWrapper: {
    display: "flex",
    alignItems: "center",
    background: "#fff",
    borderRadius: 12,
    border: "1px solid #d9d9d9",
    padding: "8px 12px",
    width: 350,
  },

  copiedBadge: {
    background: "#52c41a",
    color: "#fff",
    padding: "8px 16px",
    borderRadius: 20,
  },

  formCard: {
    width: "100%",
    maxWidth: 500,
    marginTop: 20,
    borderRadius: 12,
  },

  button: {
    marginTop: 30,
    width: 260,
    height: 50,
    borderRadius: 25,
    fontWeight: "bold",
    fontSize: 16,
  },
};